const ENTITIES = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
};
/**
 * Escape text for safe insertion into HTML body content.
 * Does NOT escape for use inside HTML attribute values contained in single
 * quotes - use escapeAttr for that.
 */
export function escapeHtml(value) {
    return value.replace(/[&<>"']/g, (c) => ENTITIES[c] ?? c);
}
/**
 * Escape a value for insertion into an HTML attribute (double-quoted).
 */
export function escapeAttr(value) {
    return value.replace(/[&<>"]/g, (c) => ENTITIES[c] ?? c);
}
//# sourceMappingURL=escape.js.map